module.exports = __webpack_public_path__ + "static/media/hazard.6270251c.png";